import './theme/common.scss';

import Vue from 'vue';
import GlobalComponent, { popMgr } from './components/global';
import Router from './common/router';
import { initFormatFilter } from './common/format';
import directive from './common/directive';
import util from './common/util';
import global from './common/global';
import { prepareData, updateRegisterUserType } from './common/data';
import Track from './common/track';
import translate from './common/translate';
import mdLazy from './components/md-lazy.vue';
import signLog from './components/sign-log';
import advRegister from '@/components/sign-log/advertising-register/register.js';
import {
    setLeadTag,
    loginOrRegister
} from './components/sign-log/socialstudio-lead-tag.js';
import questionNaire from './components/questionnaire';
import chat from './components/chat';
import getModule from './modules/index';
import modulesMap from './modules/module-map';
// import mergeResource from './merge-resource';
import getStore from './store/index';
import { mapState, mapGetters } from 'vuex';
import { initOneStepLogin } from './common/google-login-one-step';
import {
    LOGIN,
    SET_PAGE,
    SET_MODULEDATA,
    UPDATE_IS_MOBILE_SIZE,
    UPDATE_SEARCH_MOBILE_SIZE,
    UPDATE_WINDOW_SIZE,
    UPDATE_SEARCH_CENTER,
    HANDLE_GLOBAL_LNG_DATA,
    HANDLE_MODULE_LNG_DATA
} from './store/mutation-types';
import vow from './components/vow';
import onAutoPopup, { getAgreementTitleContent } from './common/autopopup.js';
// import { findSearchBar } from './common/utils/find-search-bar';
import { registerStoreModule } from '@/store/register-module';
import { init as initRequirePhone } from './components/require-phone';
import plugin from './plugins';
import './common/rendebug';
import initCookieAuthority from './components/cookieAuthority';
// hidden this componnet in v3.61
// import initTermsOfUse from './components/termsOfUse';
import initCopyRight from './modules/md-copy-right';
import FastClick from 'fastclick';
import './loadFont';

import gaConversion from './common/ga-conversion';
import trackBingAd from './common/track/bing-ad';

import VueGlobalization from './globalization/vue-globalization';
import globalization from './globalization';
import { getLngTime } from '@/common/format/date-format';
import dirty from '@/dirty';
const isScreenshot = util.isScreenshot; //screenshot mode
if (util.isMobile) {
    FastClick.attach(document.body);
}
FastClick.prototype.focus = function (targetElement) {
    var length;
    if (
        util.isIos &&
        targetElement.setSelectionRange &&
        targetElement.type.indexOf('date') !== 0 &&
        targetElement.type !== 'time' &&
        targetElement.type !== 'month' &&
        targetElement.type !== 'email'
    ) {
        length = targetElement.value.length;
        targetElement.focus(); //  solve part ios Trigger keyboard insensitivity problem
        targetElement.setSelectionRange(length, length);
    } else {
        targetElement.focus();
    }
};

util.setCookie('site-search-listings', true);
console.log('site-search-listings', util.getCookie('site-search-listings'));

window.sitePrepareData = function () {
    // return prepareData('fetch');
    return window.siteStore.state.page.page;
};
let SiteVue = (window.SiteVue = window.SiteVue || Vue);
SiteVue.use(initFormatFilter);
SiteVue.use(directive);
SiteVue.use(plugin);
SiteVue.use(VueGlobalization);
SiteVue.prototype.$EventBus = new SiteVue();

Vue.config.warnHandler = window.rendebug.sendVueWarn;
Vue.config.errorHandler = function (err, vm, info) {
    window.rendebug.sendVueError(vm, err, info);
    console.error(err);
};
Vue.config.devtools = process.env.NODE_ENV !== 'production';
const replaceFontSize = (node, size) => {
    for (let i = 0, len = node.childNodes.length; i < len; i++) {
        const nodeItem = node.childNodes[i];
        if (nodeItem.nodeType === 1) {
            const fontSize = nodeItem.style.fontSize;
            if (fontSize) {
                nodeItem.style.fontSize = parseInt(fontSize) / size + 'em';
                replaceFontSize(nodeItem, parseInt(fontSize));
            } else {
                replaceFontSize(nodeItem, size);
            }
        }
    }
};

SiteVue.prototype.formatFontSize = function (value, size) {
    if (!size) {
        size = 14;
    }
    const reg = /font-size:\s*(\d+)px/g;
    const match = value.match(reg);
    if (match && match.length > 1) {
        const div = document.createElement('div');
        div.innerHTML = value;
        replaceFontSize(div, size);
        return div.innerHTML;
    } else {
        const newValue = value.replace(reg, function (a, b) {
            return `font-size: ${parseInt(b) / size}em`;
        });
        return newValue;
    }
};
GlobalComponent(SiteVue);
window.siteModulesMap = modulesMap;
const store = (window.siteStore = getStore(SiteVue));
store.commit(UPDATE_IS_MOBILE_SIZE, util.isMobileSize());
store.commit(UPDATE_SEARCH_MOBILE_SIZE, util.isMobileSize(800));
global.resize(() => {
    store.commit(UPDATE_WINDOW_SIZE);
    store.commit(UPDATE_IS_MOBILE_SIZE, util.isMobileSize());
    store.commit(UPDATE_SEARCH_MOBILE_SIZE, util.isMobileSize(800));
});

const defaultComponents = {
    'md-lazy': mdLazy
};

const getPageData = () => {
    let data = window.sitePageJSON;
    if (!data) {
        console.error('resolve page data error.');
    }
    return data;
};

const transformTheme = (
    name,
    theme,
    data,
    templateValue,
    page,
    sysLanguage
) => {
    const templateConfig = (modulesMap[name] || {}).templateConfig;
    if (templateConfig) {
        let newTheme = templateConfig[templateValue];
        if (util.isString(newTheme)) {
            data.theme = theme = newTheme;
        } else if (util.isFunction(newTheme)) {
            data.theme = theme =
                newTheme.call(templateConfig, theme, data, page, sysLanguage) ||
                data.theme;
        } else if (newTheme) {
            newTheme = newTheme[theme];
            if (util.isString(newTheme)) {
                data.theme = theme = newTheme;
            } else if (util.isFunction(newTheme)) {
                data.theme = theme =
                    newTheme.call(
                        templateConfig,
                        theme,
                        data,
                        page,
                        sysLanguage
                    ) || data.theme;
            }
        }
    }
    return theme;
};

const valueChangeMap = {
    string: '',
    array: [],
    obj: {}
};

const changeThemeValue = (theme, config, value) => {
    let flag = false;
    const themes = config.themes || [];
    if (config.exclude === undefined) {
        flag = true;
    } else if (config.exclude) {
        if (!themes.includes(theme)) {
            flag = true;
        }
    } else {
        if (themes.includes(theme)) {
            flag = true;
        }
    }
    if (flag && value) {
        if (config.isHtml) {
            value = value.replace(/style\s*?=\s*?(['"])([\s\S]*?)\1/g, '');
        } else {
            value = valueChangeMap[config.type] || '';
        }
    }
    return value;
};

const changeThemeData = (theme, config, data, key) => {
    const children = config.children;
    const type = config.type || 'string';
    if (children) {
        if (type === 'array') {
            if (data[key] && data[key].length) {
                for (let i = 0, len = data[key].length; i < len; i++) {
                    changeThemeData(theme, children, data[key], i);
                }
            }
        } else if (data[key]) {
            for (let i = 0, len = children.length; i < len; i++) {
                changeThemeData(theme, children[i], data[key], children[i].key);
            }
        }
    } else {
        data[key] = changeThemeValue(theme, config, data[key]);
    }
};

const transformData = (name, theme, data) => {
    const themeConfig = (modulesMap[name] || {}).themeConfig;
    if (themeConfig) {
        for (let key in themeConfig) {
            data[key] && changeThemeData(theme, themeConfig[key], data, key);
        }
    }
};

const houseThemeMap = {
    grid: 'grid-v3',
    'grid-': 'grid-v3',
    'grid-template1': 'grid-v1',
    'grid-standard': 'grid-v2',
    'grid-template4': 'grid-v3',
    list: 'list-v2',
    'list-': 'list-v2',
    'list-template1': 'list-v1',
    'list-standard': 'list-v2',
    'list-template4': 'list-v3'
};

const processModuleData = (globalData, data, page, _isPreview) => {
    let prefix = new Date().getTime(),
        themeConfig = globalData.themeConfig || {},
        { templateValue, templateChangeTime, themeChangeTime } = themeConfig,
        updateTime = globalData.updateTime || 0,
        isTemplateChange =
            !globalData.ignoreTemplateChange && templateChangeTime > updateTime,
        isThemeChange =
            !globalData.ignoreThemeChange && themeChangeTime > updateTime;
    data.forEach((item, index) => {
        if (item.vdata) return item;
        item = registerStoreModule(item, store);
        // const storeName = generateModuleName(item.name);
        let id = item.id || `${prefix}-${index}`,
            theme = item.data?.theme || item.commonData?.theme || 'standard',
            itemData = Object.assign(
                {},
                item.commonData || {},
                item.data || {}
            );
        // mergeLanguageToData(item.name, itemData, item.sysLanguage);
        if (
            isTemplateChange &&
            !['md-header', 'md-footer'].includes(item.name)
        ) {
            theme = transformTheme(
                item.name,
                theme,
                itemData,
                templateValue,
                page,
                item.sysLanguage
            );
        }
        if (isThemeChange) {
            transformData(item.name, theme, itemData);
        }
        if (item.name === 'md-house' && ['grid', 'list'].includes(theme)) {
            theme =
                houseThemeMap[theme + '-' + (itemData.style || '')] ||
                houseThemeMap[theme];
            itemData.theme = theme;
            itemData.style = '';
        }
        //  No landing page in the case of   renew globalData of registerUserType
        if (!globalData.isLandingpage && item.name === 'md-detail-info') {
            let type;
            if (
                (type = util.getValueByPath(
                    item,
                    'data.listingDetail.info.purchaseType'
                ))
            ) {
                updateRegisterUserType(type, globalData);
            }
        }
        Object.assign(item, {
            id: id,
            module: item.module || true,
            visible: item.visible || false,
            moduleLoad: false,
            moduleRender: false,
            moduleMounted: false,
            loadingPs: null,
            noObserve: globalData.lazyMode === false || itemData.noObserve,
            theme: theme,
            componentName: item.name + '-' + theme,
            vdata: {
                props: { id: id, sss: 'xxx' },
                key: id
                // $storeName: storeName
            },
            getVdata(self, item) {
                return { ...item.vdata };
            },
            data: itemData,
            i18next: {
                ns: ''
            }
        });
    });
    return data;
};

const checkInitChat = function (globalData) {
    return !(
        util.isBot ||
        !util.isReallyUser ||
        (advRegister.isShow(globalData) &&
            globalData.pageKey === 'listing' &&
            globalData.isLandingPage) ||
        globalData.pageKey === 'password-reset' ||
        globalData.pageKey === 'password-forget' ||
        isScreenshot
    );
};

const getAppConfig = ({ el, moduleData, oninit, page }) => {
    // eslint-disable-next-line no-useless-call
    const initConfig = (oninit && oninit.call(null, moduleData)) || {};
    const defaultConfig = {
        el: el || '#app',
        data: {
            moduleData,
            hideChat: false,
            scrollY: 0,
            beforeFullScreenScrollY: 0,
            hasSetleadTag: false
        },
        store,
        computed: {
            // allModuleMounted() {
            //     let mounted = this.moduleData.every(
            //         item =>
            //             item.moduleMounted || (item.visible && !item.moduleLoad)
            //     );
            //     if (mounted && window.siteAppVm)
            //         window.siteAppVm.$emit('allModuleMounted');
            //     return mounted;
            // },
            isHideChat() {
                const moduleStore = this.$store.findFirstSearchBarModule();
                return (
                    (this.hideChat ||
                        (moduleStore &&
                            moduleStore.state.layout === 'map' &&
                            (this.globalData.pageKey === 'listing' ||
                                this.globalData.pageKey === 'sold-listing'))) &&
                    !util.inCmsSetting
                );
            },
            ...mapState({
                globalData: state => state.page.page,
                user: state => state.user.user,
                loginStatus: state => state.user.loginStatus,
                currentLanguage: state => state.page.currentLanguage,
                socialTagType: state => state.common.socialTagType
            }),
            ...mapGetters('page', ['translatorType'])
        },
        render(h) {
            let fromGlobalSetting = this.globalData.fromGlobalSetting || false;
            let renderComponent = item => {
                if (
                    item.name !== 'module-loading' &&
                    item.module &&
                    !item.visible &&
                    !item.moduleLoad
                ) {
                    return h('md-lazy', {
                        on: {
                            visible: () => {
                                if (!item.visible) {
                                    const loadingPs = (item.loadingPs =
                                        getModule(
                                            this.$options.components,
                                            item.componentName,
                                            item.name,
                                            item.theme,
                                            this.modulesMap,
                                            undefined,
                                            this.globalData
                                        )
                                            .then(() => {
                                                if (
                                                    loadingPs === item.loadingPs
                                                ) {
                                                    item.loadingPs = null;
                                                    item.visible = true;
                                                    item.moduleLoad = true;
                                                }
                                            })
                                            .catch(error => {
                                                console.log(error);
                                                if (
                                                    loadingPs === item.loadingPs
                                                ) {
                                                    item.visible = true;
                                                }
                                            }));
                                }
                            }
                        },
                        key: item.id,
                        props: {
                            moduleName: item.name,
                            noObserve: item.noObserve,
                            hasLoadingPs: !!item.loadingPs
                        }
                    });
                } else if (item.name === 'module-loading') {
                    return h('md-lazy');
                } else if (item.moduleLoad) {
                    return h(
                        item.componentName,
                        item.getVdata
                            ? item.getVdata(this, item)
                            : { ...(item.vdata || {}) }, //  module data
                        item.content || ''
                    );
                } else if (process.env.NODE_ENV === 'development') {
                    return h(
                        'div',
                        {
                            class: 'md-error'
                        },
                        `module ${item.name}(theme:${item.theme}) load fail`
                    );
                }
            };
            if (this.moduleData.length || fromGlobalSetting) {
                const templateValue = this.globalData.template || '';
                var modules = this.moduleData;
                return h(
                    'main',
                    Object.assign(
                        {
                            class: [
                                'page-content',
                                templateValue,
                                { 'hide-chat': this.isHideChat },
                                { 'preview-in-cms': util.inCms }
                            ]
                        },
                        initConfig.renderOptions
                    ),
                    modules.map(renderComponent)
                );
            } else {
                return h(
                    'div',
                    {
                        class: [
                            'page-content',
                            { 'preview-in-cms': util.inCms }
                        ]
                    },
                    [
                        h('div', { class: 'empty-container' }, [
                            h(
                                'p',
                                'This page is still under construction but will be available soon!'
                            )
                        ])
                    ]
                );
            }
        },
        created() {
            this.modulesMap = modulesMap;
        },
        mounted() {
            global.scroll(this.onscroll);
            document.addEventListener(
                'webkitfullscreenchange',
                this.fullscreenChange,
                false
            );
            if (this.user) {
                if (!this.hasSetleadTag) {
                    setLeadTag(
                        loginOrRegister.login,
                        this.user.id || '',
                        this.user.teamId || ''
                    );
                    this.hasSetleadTag = true;
                }
            } else {
                signLog.authByUrl();
            }

            //  in the case of google translate ,  To start the initialization
            if (
                this.translatorType === 'googlePlugin' &&
                this.currentLanguage !== 'en'
            ) {
                translate.googleTranslate({ value: this.currentLanguage });
            }

            Track.prepare();
            //  Reset when the page is initialized track handler
            Track.resetEventHandler();
        },
        watch: {
            user() {
                if (
                    !this.user &&
                    this.globalData.registration &&
                    this.globalData.registration.autopopup &&
                    this.globalData.registration.autopopup.triggerType == 4 &&
                    this.globalData.registration.autopopup.type != 0 &&
                    util.getQueryField('isPopup') != 1
                ) {
                    setTimeout(() => {
                        this.openSignLog({
                            questionMsg: this.$t('common:register.questionMsg')
                        });
                    }, 1000 * 60);
                }
                if (this.user && !this.hasSetleadTag) {
                    setLeadTag(
                        this.socialTagType,
                        this.user.id || '',
                        this.user.teamId || ''
                    );
                    this.hasSetleadTag = true;
                }
            }
        },
        methods: {
            fullscreenChange() {
                if (
                    !document.webkitIsFullScreen &&
                    this.beforeFullScreenScrollY
                ) {
                    global.scroll(this.beforeFullScreenScrollY);
                }
            },
            onscroll(scrollY) {
                if (
                    this.scrollY &&
                    scrollY === 0 &&
                    document.webkitIsFullScreen
                ) {
                    this.beforeFullScreenScrollY = this.scrollY;
                }
                this.scrollY = scrollY;
                if (util.isMobile) {
                    return;
                }
                //  distance from bottom 200 Do not display within chat
                var notFromBottom200 =
                    document.documentElement.clientHeight +
                        window.scrollY +
                        200 <
                    document.body.clientHeight;
                if (notFromBottom200) {
                    this.displayChat(true);
                } else {
                    this.displayChat(false);
                }
            },
            displayChat(isShow) {
                this.hideChat = !isShow;
            },
            updateChat(chatAndCaptureForm, logOutFlag) {
                if (checkInitChat(this.globalData)) {
                    chat.init(
                        this,
                        {
                            chatAndCaptureForm
                        },
                        logOutFlag
                    );
                }
            },
            closeChat() {
                chat.destroyChat();
            },
            openCaptureForm(options = {}, popReplace = false) {
                signLog.register(options, 'chatRegister', popReplace);
            },
            openSignLog(options = {}, popReplace = false) {
                this.signLogOptions = options;
                !this.user &&
                    signLog.register(options, options.style, popReplace, true);
            },
            closePop() {
                popMgr.closeAllPopWin();
            },
            changeSignLogStyle(style, popReplace = false) {
                this.signLogOptions &&
                    this.openSignLog(this.signLogOptions, popReplace);
            },
            openQuestionNaire(options = {}, type, popReplace = false) {
                this.questionNaireOptions = options;
                questionNaire.open({
                    options,
                    type,
                    style: options.style,
                    popReplace,
                    globalData: this.globalData
                });
            },
            changeQuestionNaireType(type, popReplace = false) {
                this.questionNaireOptions &&
                    this.openQuestionNaire(
                        this.questionNaireOptions,
                        type,
                        popReplace
                    );
            },
            refresh(moduleData, pos) {
                moduleData = processModuleData(
                    this.globalData,
                    moduleData,
                    page,
                    false
                );
                this.moduleData = moduleData;
                store.commit(`page/${SET_MODULEDATA}`, moduleData);
                store.commit(`page/${HANDLE_MODULE_LNG_DATA}`);
                if (!isNaN(pos)) {
                    this.$nextTick(() => {
                        util.winScrollTop(pos);
                    });
                }
            },
            fillModuleDataProp(data, index) {
                const prefix = new Date().getTime();
                const id = data.id || `${prefix}-${index}`;
                const theme = data.data.theme || 'standard';
                data = registerStoreModule(data, store);
                // const storeName = generateModuleName(data.name);
                return Object.assign(data, {
                    id,
                    theme,
                    module: data.module || true,
                    visible: data.visible || false,
                    moduleLoad: false,
                    moduleRender: false,
                    moduleMounted: false,
                    componentName: data.name + '-' + theme,
                    vdata: {
                        props: { id: id },
                        key: id
                        // $storeName: storeName
                    },
                    getVdata(self, item) {
                        return { ...item.vdata };
                    },
                    data: Object.assign(
                        {},
                        data.commonData || {},
                        data.data || {}
                    )
                });
            },
            changeMouduleTheme(moduleId, theme) {
                const moduleData = this.moduleData,
                    idx = util.indexOf(moduleData, moduleId, 'id');
                let module = moduleData[idx];
                module.theme = theme;
                module.data.theme = theme;
                module.componentName = module.name + '-' + theme;
                module.visible = false;
                module.moduleLoad = false;
                module.moduleRender = false;
                module.moduleMounted = false;
                if (module.loadingPs) {
                    module.loadingPs = null;
                }
            },
            moduleRefresh(moduleId) {
                const moduleData = this.moduleData;
                const idx = util.indexOf(moduleData, moduleId, 'id');
                const prefix = new Date().getTime();
                const id = `${prefix}-${idx}`;
                moduleData[idx].id = id;
                moduleData[idx].vdata.props.id = id;
                moduleData[idx].vdata.key = id;
            },
            componentRefresh(moduleId, theme) {
                const moduleData = this.moduleData;
                const idx = util.indexOf(moduleData, moduleId, 'id');
                const componentName = moduleData[idx]['componentName'];
                this.$options.components[componentName] = null;
                //  reload component
                this.changeMouduleTheme(moduleId, theme);
            },
            getCurPop: function () {
                return popMgr.getCurrent();
            },
            /** Event triggered when the mouse moves out of the browser's visible area  CHIME-13995 */
            mouseLeaveView() {
                signLog.register({ mouseLeaveAllowClose: true });
            },
            changeLanguage(lng, { needRefresh } = {}) {
                if (needRefresh) {
                    store.dispatch(`page/setLanguage`, lng);
                    window.location.reload();
                } else {
                    store.dispatch(`page/setLanguage`, lng);
                    lng = store.state.page.currentLanguage;
                    //  global data ： User editable text
                    store.commit(`page/${HANDLE_GLOBAL_LNG_DATA}`);
                    //  module ： User editable text
                    store.commit(`page/${HANDLE_MODULE_LNG_DATA}`);
                    //  Code Internal Copywriting
                    globalization.changeLanguage(lng);
                    /**
                     *  Pay attention to timing issues
                     *  after processing site After the whole station data ， Notify again vuex
                     *  The data that can be obtained by all triggers that monitor this property is the data after switching
                     */
                    !util.inCmsSetting &&
                        this.updateChat(this.globalData.chatAndCaptureForm);
                }
            }
        },
        destroyed() {
            document.removeEventListener(
                'webkitfullscreenchange',
                this.fullscreenChange,
                false
            );
        },
        components: defaultComponents
    };
    return {
        mixins: [defaultConfig, initConfig.vueOptions || {}]
    };
};

const sitePageInit = (window.sitePageInit = (
    { el, oninit, pageData, globalData, router, unique } = {},
    pos
) => {
    /*
     *  This returned by the backend pageData corresponds to /assets/config/pages/< Which set of templates >/< page >.json  inside json data
     */
    pageData = pageData || getPageData();
    if (util.isPageSpeed && pageData.modules) {
        //  in the case of  nodejs  of  puppeteer  rendering
        //  in the case of  nodejs  run static page do  seo  then do not truncate
        pageData.modules = pageData.modules.slice(0, 4);
    }
    // clone  Prevent modifying data from reporting errors
    globalData = util.deepClone(prepareData(globalData));
    util.setGlobalData(globalData);

    store.commit(LOGIN, { user: globalData.loginInfo || 0 });
    if (
        util.isReallyUser &&
        !util.inCms &&
        process.env.CHIME_ENV == 'production'
    ) {
        // rendebug load
        // window.rendebug.setOn(globalData.site && globalData.site.reportDebug);
        window.rendebug.setOn(Date.now() % 10 === 0);
    }
    store.commit(UPDATE_SEARCH_CENTER, globalData.searchCenter);
    if (window.sitePageAutoInit !== false && globalData.redirectUrl) {
        let mts = globalData.redirectUrl.match(/(?:\/\/([^/]+))?(\/[^?]+)/);
        if (
            mts &&
            ((mts[1] && mts[1] !== window.location.host) ||
                mts[2] !== window.location.pathname)
        ) {
            window.location = globalData.redirectUrl;
            return;
        }
    }
    //  on the page hideChat configuration into showLauncher
    if (globalData.chatAndCaptureForm) {
        globalData.chatAndCaptureForm.showLauncher =
            !globalData.hideChat && globalData.chatAndCaptureForm.showLauncher;
    }
    //  this customCode is a custom style ,  exist cms->setting->Tools->Custom Style & Script It can be configured ,  it is this site All pages below will get
    let customCode = globalData.customCode || {};
    if (customCode.style) {
        util.addStyle(customCode.style);
    }
    // util.addStyle('//static.chimeroi.com/servicetool-temp/site_font_block.css');
    // if (!isNaN(pos)) {
    // cms Edit interface go here
    let styleEl = document.getElementById('page-style');
    if (styleEl) {
        styleEl.parentNode.removeChild(styleEl);
    }
    let pageCss = pageData?.css;
    if (pageCss) {
        util.addStyle(pageCss, false).setAttribute('id', 'page-style');
    }
    // }
    let page = globalData.pageKey,
        moduleData = processModuleData(
            globalData,
            pageData.modules,
            page,
            util.inCms
        );

    store.commit(`page/${SET_PAGE}`, globalData);
    store.commit(`page/${SET_MODULEDATA}`, moduleData);
    //  according to cookie initialization currentLanguage
    store.dispatch(`page/initCurrentLang`);
    store.dispatch(`page/initCurrency`);
    let lng = store.state.page.currentLanguage;
    store.commit(`page/${HANDLE_GLOBAL_LNG_DATA}`);
    store.commit(`page/${HANDLE_MODULE_LNG_DATA}`);
    globalization.init(lng, globalData.terminologyMap, globalData);
    getLngTime(lng);
    let // mergeKey = globalData.mergeResourceKey || '',
        // mergeFun = mergeResource[mergeKey],
        promiseArr = [];

    // If the browser does not support IntersectionObserver then add polyfill
    if (!window.IntersectionObserver) {
        promiseArr.push(
            util.addScript(
                '//static.chimeroi.com/lib/polyfill/IntersectionObserver.js',
                true,
                true
            )
        );
    }
    if (!window.ResizeObserver) {
        promiseArr.push(
            util.addScript(
                '//static.chimeroi.com/lib/polyfill/ResizeObserver.js',
                true,
                true
            )
        );
    }
    try {
        dirty({ globalData });

        //  Remove the parent window of the details page pop-up window loading
        if (util.inPopDetailPage) {
            window.parent.__curDetailPop.setLoading(false);
        }
    } catch (e) {
        console.warn(e);
    }
    if (promiseArr.length) {
        return Promise.all(promiseArr).then(() => {
            var r = initSiteAppVm(
                page,
                moduleData,
                pos,
                el,
                oninit,
                router,
                globalData,
                pageData,
                customCode,
                unique
            );
            // Track.prepare();
            // //  Reset when the page is initialized track handler
            // Track.resetEventHandler();
            return r;
        });
    } else {
        var r = initSiteAppVm(
            page,
            moduleData,
            pos,
            el,
            oninit,
            router,
            globalData,
            pageData,
            customCode,
            unique
        );

        // Track.prepare();
        // //  Reset when the page is initialized track handler
        // Track.resetEventHandler();
        return Promise.resolve(r);
    }
});

function initSiteAppVm(
    page,
    moduleData,
    pos,
    el,
    oninit,
    router,
    globalData,
    pageData,
    customCode,
    unique
) {
    if (window.siteAppVm && !unique) {
        document.body.className = 'site ' + page;
        if (util.isMobile) {
            document.body.classList.add('mobile');
        }
        window.siteAppVm.closePop();
        window.siteAppVm.refresh(moduleData, pos);
    } else {
        window.siteAppVm = new SiteVue(
            getAppConfig({
                el,
                moduleData,
                oninit,
                page
            })
        );
        if (
            router === false ||
            globalData?.site?.singlePage === false ||
            util.inApp
        ) {
            Router.multiPageInit(window.siteAppVm);
        } else if (router !== false && globalData?.site?.singlePage !== false) {
            // Router.init(sitePageInit, window.siteAppVm);
            Router.multiPageInit(window.siteAppVm); //  temporary plan , The server needs to put the parameters into the global data  URI_REQUEST_PARAMS
        }
        //  ask cookie
        !isScreenshot && initCookieAuthority(SiteVue, store);
        initRequirePhone(window.siteAppVm);

        if (globalData.hasCopyRight) {
            initCopyRight(SiteVue, store);
        }
    }

    const closeCallback = () => {
        let { loginCallback } = globalData.scheduleAnchor;
        loginCallback &&
            loginCallback() &&
            (globalData.scheduleAnchor.loginCallback = null);
    };

    if (util.getQueryField('isPopup') == 1) {
        //  Not logged in strong bomb login box
        store
            .dispatch('getUser', {
                checkOtherIframe: true,
                fromGlobal: true
            })
            .then(isLogin => {
                if (!isLogin) {
                    window.siteAppVm.openSignLog({
                        onClose: () => closeCallback(),
                        onsuccess: () => closeCallback(),
                        allowClose:
                            globalData.registration?.autopopup?.allowClose
                    });
                }
            });
    } else if (window.sitePageAutoInit !== false) {
        // window.siteAppVm.isVow = false;
        let options = getAgreementTitleContent(
                globalData.mlsOrgs,
                globalData.pageKey,
                pageData
            ),
            isHasPopupRule =
                (globalData.registration &&
                    globalData.registration.autopopup) ||
                util.getCookie('source');
        // eslint-disable-next-line no-inner-declarations
        function popUpFunc() {
            store
                .dispatch('getUser', {
                    checkOtherIframe: true,
                    fromGlobal: true
                })
                .finally(() => {
                    console.log(globalData.registration.autopopup);
                    onAutoPopup(
                        window.siteAppVm,
                        Object.assign(globalData.registration.autopopup, {
                            closeCallback
                        })
                    );
                    globalData.googleAppId &&
                        globalData.enableGSI !== false &&
                        initOneStepLogin(globalData, store);
                });
        }
        if (options) {
            window.siteAppVm.$EventBus.$emit('vow-popup');
            vow.open(
                options,
                0,
                () => {
                    window.siteAppVm.$EventBus.$emit('vow-close');
                    if (isHasPopupRule) {
                        popUpFunc();
                    }
                },
                undefined,
                globalData
            );
        } else if (isHasPopupRule) {
            popUpFunc();
        }
    }
    if (pageData.script) {
        new Function(pageData.script).call(window.siteAppVm);
    }
    if (customCode.script) {
        try {
            new Function(customCode.script)();
        } catch (e) {
            console.error('Custom Script Error: ' + e);
        }
    }
    if (globalData.pageKey) {
        document.body.classList.add(globalData.pageKey);
    }
    if (globalData.isTestSite) {
        document.body.classList.add('test-site');
    }
    if (globalData.siteStatus === 0) {
        document.body.classList.add('pending');
    }

    if (window.siteAppVm && !unique) {
        window.siteAppVm.$EventBus.$emit('siteTrack', {
            trackType: 'page-change'
        });
    }

    if (util.isReallyUser) {
        // crm traffic report  Statistical data
        new Image().src = '/0.gif?u=' + (globalData.requestId || '');
    }

    if (checkInitChat(globalData)) {
        chat.init(window.siteAppVm, globalData);
    }
    return window.siteAppVm;
}

if (window.sitePageAutoInit !== false) {
    if (document.querySelector('.preview')) {
        //Lighthouse Use the preview image directly ,  kill this
        document.querySelector('.preview').remove();
    }
    sitePageInit();

    //css var variable compatibility
    const isNativeSupport =
        window.CSS && window.CSS.supports && window.CSS.supports('(--a: 0)');
    if (!isNativeSupport) {
        util.addScript(
            'https://static.chimeroi.com/servicetool-temp/site-cdn/css-vars-ponyfill.min.js',
            true
        ).then(() => {
            window.cssVars &&
                window.cssVars({
                    include:
                        'style,link[href*="/static/"],link[type="text/css"][href*="/site-static/"],link[type="text/css"][href*="static.chimeroi.com"]',
                    watch: true
                });
        });
    }
}

// ga conversion
gaConversion();

// bing  Buried
trackBingAd();

//  set time zone
util.setCookie('timezone', util.getTimeZone());

// social  The parameter capture
if (util.getQueryField('cpclid')) {
    util.setCookie('cpclid', util.getQueryField('cpclid'), 7);
}

// Search optimization
let debugRealTimeListing = util.getQueryField('debug-realTimeListing');
if (debugRealTimeListing === '1') {
    util.setCookie('debug-realTimeListing', '1');
} else if (debugRealTimeListing === '0') {
    util.removeCookie('debug-realTimeListing');
}

export default sitePageInit;
// eslint-disable-next-line no-undef
console.log('__BUILD_ID__', __BUILD_ID__);
// eslint-disable-next-line no-undef
console.log('__chime env__', process.env.CHIME_ENV);
if (
    document.currentScript?.src &&
    typeof document.currentScript.src === 'string'
) {
    console.log(
        'CODE CDN :',
        document.currentScript.src.startsWith('https://static.chimeroi.com')
    );
}
